import { memo, useCallback, useMemo, useState } from "react";
import { Edit } from "@mui/icons-material";
import { TextField, IconButton, InputAdornment } from "@mui/material";
import PropTypes from "prop-types";

import { useToaster } from "hooks";

import { error } from "constants";

const FGEditableView = ({
  lineItemData = "",
  doId,
  onEditDoQty,
  isApproveRejectRefreshAction,
}) => {
  const fgQty = +lineItemData?.fgReadyQtyValue + +lineItemData?.expectedFgValue;

  const [value, setValue] = useState(fgQty);
  const [editable, setEditable] = useState(false);

  const triggerToaster = useToaster();

  const handleEditClick = useCallback(() => {
    setEditable(true);
  }, []);

  const handleKeyDown = useCallback((e) => {
    if (e.key === "-" || e.key === "e" || e.key === "E") {
      e.preventDefault();
    }
  }, []);

  const handleChange = useCallback(
    (e) => {
      const val = +e.target.value;
      if (val < 0) {
        triggerToaster("Enter a quantity greater than or equal to 0", error);
      } else if (val <= fgQty) {
        setValue(e.target.value);
      } else {
        triggerToaster(
          "Enter a quantity less than or equal to the FG quantity",
          error,
        );
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [lineItemData?.fgReady],
  );

  const handleBlur = useCallback(() => {
    setEditable(false);
    onEditDoQty?.(value, lineItemData?.lineItemId, doId);
  }, [doId, lineItemData?.lineItemId, onEditDoQty, value]);

  const inputProps = useMemo(
    () => ({
      endAdornment: !isApproveRejectRefreshAction ? (
        <InputAdornment position="end">
          <IconButton
            size="small"
            onClick={handleEditClick}
            edge="end"
            tabIndex={-1}
          >
            <Edit fontSize="small" />
          </IconButton>
        </InputAdornment>
      ) : null,
    }),
    [handleEditClick, isApproveRejectRefreshAction],
  );

  return (
    <TextField
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
      variant="outlined"
      size="small"
      min={0}
      disabled={!editable}
      sx={{
        width: "100px",
      }}
      type="number"
      InputProps={inputProps}
    />
  );
};

export default memo(FGEditableView);

FGEditableView.propTypes = {
  lineItemData: PropTypes.object,
  onEditDoQty: PropTypes.func,
};
